/***
**Module Name: team
 **File Name :  team.js
 **Project :    Orasi Media
 **Copyright(c) : X Platform Consulting.
 **Organization : Peafowl Inc
 **author :  chandrasekhar
 **author :  Hari
 **license :
 **version :  1.0.0
 **Created on :
 **Created on: Dec 27 2022
 **Last modified on: Dec 27 2022
 **Description : contains team page details.
 ***/
import React, { useEffect, useState, useContext } from "react";

// import "../../src/assets/css/style.css"
import tmdbApi from "../api/tmdbApi";
import Header from "../components/header/Header";
import Footer from "../components/footer/Footer";
import ReactHtmlParser from 'react-html-parser';
import $ from "jquery";
import * as Config from "../constants/Config";
import InsideHeader from "../components/InnerHeader/Header";
import { contentContext } from "../context/contentContext";
import Modal from 'react-bootstrap/Modal';
import LandingHeader from "../components/LandingHeader/Header";

const Team = () => {

  const [config, setConfig] = useState({});
  const [teamBoard, setTeamBoard] = useState({});
  const [teamMember, setTeamMember] = useState({});
  const [about, setAbout] = useState('');
  const { menus ,setContentSearchFlag,contentSearchFlag, setRoute} = useContext(contentContext);
  const [showDescription, setShowDescription] = useState(false);

  useEffect(() => {
    if (window.site) {
      setConfig(window.site);

    }
    setContentSearchFlag(false)
    setRoute("notcontent")
  }, [window.site]);

 const img = config.common?.imagesCDN;

  useEffect(() => {
    
      menus && menus.length > 0 && menus.map(function (item, i) {
        if (item.menuid === 100003) {
          setTeamBoard(item.team[0].members);
          setTeamMember(item.team[1].members)
        }
      })
    

  }, [menus]);


  const handleDescription = (e,item) => {
    setAbout(item)
    setShowDescription(!showDescription)
  }


  const cardWidth = $(".team-card-img-block").width();
  const cardWidth1 = $(".team-card-thumb").width();
  return (
    <>
     <Modal show={showDescription} onHide={handleDescription} className="modal title-des-popup" id="descriptionPopup" >
        <Modal.Header closeButton>
          <Modal.Title>About</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <p style={{ whiteSpace: "pre-line" }}>{about}</p>

        </Modal.Body>


      </Modal>

      {/* <Header menus={menus} activeClass={"100003"} /> */}
      {localStorage.getItem("token") ? <InsideHeader activeClass={"5"} /> : <LandingHeader menus={menus} activeMenu={"aboutus"} activeClass={"100003"}/>}
      <main id="main">
  <div className="section inner-container team" id="team-section">
    {/* <!-- <h1 className="heading mt-5 text-center" >OUR  TEAM</h1> --> */}
    <h1 className="sec-heading mt-5" id="board-title">THE <span id="board-title-span">BOARD</span></h1>

    <div className="container" id="board-container">
      <div className="team-lg-wrapper" id="board-wrapper">
        <div className="row team-section" id="board-row">
          {teamBoard && teamBoard.length > 0 && teamBoard.map((item, i) => {
            return (
              <div className="col-md-6 board-members" id={`board-member-${i}` }  key={item?.teamid}   >
                <div className="team-card lg" id={`board-card-${i}`}>
                  <div className="team-card-header yellow-gradient" id={`board-card-header-${i}`}>
                    <div className="team-profile-block" id={`board-profile-block-${i}`}>
                      <div className="team-card-img-block" id={`board-img-block-${i}`}>
                        {item.profileimage === undefined ? 
                          <img id={`board-img-${i}`} src={img+"orasi/team/default-team.png?auto=compress,format&width=" + cardWidth}  alt={"Profile image"}  /> : 
                          <img id={`board-img-${i}`} src={item.profileimage + "?auto=compress,format&width=" + cardWidth}  alt={"Profile image"} />}
                      </div>
                      <div className="team-title-block" id={`board-title-block-${i}`}>
                        <h4 id={`board-name-${i}`}>{item.title}</h4>
                        <p className="profile-badge" id={`board-designation-${i}`}>{item.designation}</p>
                        {item?.email && item?.email.trim() != "" &&  
                          <p className="team-contact" id={`board-email-${i}`}>
                            <span className="material-icons-outlined">email</span>{item.email}
                          </p>}
                        {item?.phone && item?.phone.trim() != "" && 
                          <p className="team-contact mb-0" id={`board-phone-${i}`}>
                            <span className="material-icons">phone</span>{item.phone}
                          </p>}
                      </div>
                    </div>
                  </div>
                  <div className="team-card-body" id={`board-body-${i}`}>
                    {ReactHtmlParser(item.descriptioncontent)}
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>

    <h1 className="sec-heading mt-5" id="sales-title">SALES <span id="sales-title-span">TEAM</span></h1>

    <div className="container" id="sales-container">
   <div className="row team-section" id="sales-row">
  {teamMember && teamMember.length > 0 && teamMember.map((item, i) => {
    return (
      <div
        className="col-md-3 col-sm-6 col-xs-6 sales-team"
        id={`sales-member-${i}`}
        key={item?.teamid}  
      >
        <div className="team-card" id={`sales-card-${i}`}>
          <div className="team-card-thumb" id={`sales-thumb-${i}`}>
            {item.profileimage === undefined ? 
              <img id={`sales-img-${i}`} src={img+"orasi/team/default-team.png?auto=compress,format&width=" + cardWidth1}  alt={"Profile image"}  /> : 
              <img id={`sales-img-${i}`} src={item.profileimage + "?auto=compress,format&width=" + cardWidth1}  alt={"Profile image"}  /> }
          </div>
          <div className="team-card-footer" id={`sales-footer-${i}`}>
            <h3 className="team-title" id={`sales-name-${i}`}>{item.title}</h3>
            <p className="profile-badge-sm mb-3" id={`sales-designation-${i}`}>{item.designation}</p>
            <p className="team-para" id={`sales-about-${i}`}>{item?.about}</p>
            <p className="team-mobile-para" id={`sales-mobile-about-${i}`}>{item?.about}</p>
            {item?.about.length > 125 ? ( 
              <a className="full-details mobile" id={`sales-details-link-${i}`} onClick={(e)=>handleDescription(e,item?.about)}>
                full details<span className="material-icons-outlined">chevron_right</span>
              </a> 
            ) : null}
            {item?.phone && item?.phone.trim() != "" &&  
              <p className="sales-contact" id={`sales-phone-${i}`}>
                <span className="material-icons">phone</span>{item.phone}
              </p>}
            {item?.email && item?.email.trim() != "" &&   
              <p className="slaes-email-contact" id={`sales-email-${i}`}>
                <span className="material-icons">email</span>{item.email}
              </p>}
          </div>
        </div>
      </div>
    )
  })}
</div>

    </div>
  </div>
</main>


      <Footer menus={menus} />
    </>
  );
};

export default Team;